import PendoAlert from '../../components/alert/pendo-alert.vue.js';
import PendoButton from '../../components/button/pendo-button.vue.js';
import PendoLoadingIndicator from '../../components/loading-indicator/pendo-loading-indicator.vue.js';
import PendoModal from '../../components/modal/pendo-modal.vue.js';
import PendoRadioGroup from '../../components/radio-group/pendo-radio-group.vue.js';
import PendoRadio from '../../components/radio/pendo-radio.vue.js';
import PendoTable from '../../components/table/pendo-table.vue.js';
import PendoInput from '../../components/input/pendo-input.vue.js';
import PendoIcon from '../../components/icon/pendo-icon.vue.js';
import PendoNotification from '../../components/notification/pendo-notification.js';
import AddExcludeListStagingItemModal from './add-exclude-list-staging-item-modal.vue.js';
import debounce from 'lodash/debounce.js';
import escapeRegExp from 'lodash/escapeRegExp.js';

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }
  if (!value || !value.then) {
    value = Promise.resolve(value);
  }
  return then ? value.then(then) : value;
}
function _empty() {}
function _invokeIgnored(body) {
  var result = body();
  if (result && result.then) {
    return result.then(_empty);
  }
}
function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }
    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }
  if (result && result.then) {
    return result.then(void 0, recover);
  }
  return result;
}
function _continue(value, then) {
  return value && value.then ? value.then(then) : then(value);
}
var script = {
  name: 'PendoExcludeIncludeStagingListDetail',
  components: {
    PendoAlert,
    PendoButton,
    PendoLoadingIndicator,
    PendoModal,
    PendoRadioGroup,
    PendoRadio,
    PendoTable,
    PendoInput,
    PendoIcon,
    AddExcludeListStagingItemModal
  },
  props: {
    type: {
      type: String,
      required: true
    },
    serverHostDomainLabel: {
      type: String,
      default: 'Server Host/Domain'
    },
    accountUsesIncludeList: {
      type: Function,
      default: () => false
    },
    matches: {
      type: Function,
      required: true
    },
    fetchMyIpAddress: {
      type: Function,
      required: true
    },
    fetchHostsForType: {
      type: Function,
      required: true
    },
    updateHost: {
      type: Function,
      required: true
    },
    fetchExcludeListForType: {
      type: Function,
      required: true
    },
    createExcludeListItem: {
      type: Function,
      required: true
    },
    removeExcludeListItem: {
      type: Function,
      required: true
    },
    localizeApp: {
      type: Function,
      default: null
    },
    stagingModalAlertLink: {
      type: String,
      default: ''
    },
    subHasExtensionApp: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hasMoreEntries: false,
      hostEntries: [],
      initComplete: false,
      isLoading: false,
      itemToRemove: null,
      listConversionChoice: 'clear',
      loadingLabel: 'Loading...',
      modalHosts: [],
      modalHostsLoaded: false,
      modalHasMoreHosts: false,
      searchInput: '',
      showAddModal: false,
      showListConversionModal: false,
      showRemoveModal: false,
      tableLoaded: false,
      typeEntries: [],
      typeGlobEntries: [],
      resultLimit: 1000
    };
  },
  computed: {
    listEntries() {
      return [...this.hostEntries, ...this.typeEntries, ...this.typeGlobEntries];
    },
    listType() {
      return this.isStaging ? 'staging' : 'excludelist';
    },
    columnHeader() {
      if (this.type === 'server') {
        return `${this.typeVerbPastParticiple} ${this.typeLabel}`;
      }
      return this.typeLabel;
    },
    columns() {
      return [{
        prop: 'name',
        label: this.columnHeader,
        sortable: true
      }, {
        type: 'actions',
        width: 80
      }];
    },
    filteredList() {
      return this.listEntries.filter(entry => {
        if (entry) {
          const {
            name,
            type
          } = entry;
          const matches = type && this.matches ? this.matches(name, this.type, entry) : true;
          return matches && name.toLowerCase().includes(this.searchInput.toLowerCase());
        }
        return false;
      });
    },
    isHostType() {
      return this.type === 'server' || this.isStaging;
    },
    showTable() {
      return this.listEntries && this.listEntries.length > 0 && this.initComplete || this.hasMoreEntries;
    },
    typeLabel() {
      return this.typeMap[this.type].name;
    },
    typeVerb() {
      if (this.type === 'server') {
        return this.usesExcludeList ? 'Exclude' : 'Include';
      }
      return this.isStaging ? 'Add' : 'Exclude';
    },
    typeVerbPastParticiple() {
      return {
        Exclude: 'Excluded',
        Include: 'Included',
        Add: 'Added'
      }[this.typeVerb];
    },
    typeMap() {
      return {
        accountId: {
          name: 'Account ID'
        },
        ip: {
          name: 'IP Address'
        },
        server: {
          name: 'Server Host/Domain'
        },
        staging: {
          name: this.serverHostDomainLabel
        },
        visitorId: {
          name: 'Visitor ID'
        }
      };
    },
    usesExcludeList() {
      return !this.usesIncludeList;
    },
    usesIncludeList() {
      return this.accountUsesIncludeList();
    },
    listConversionOptions() {
      return [{
        value: 'clear',
        label: 'Clear List – Remove server host/domains in this list.'
      }, {
        value: 'transfer',
        label: `Transfer List – Move server host/domains to ${this.usesExcludeList ? 'Include List' : 'Exclude List'}.`
      }];
    },
    isStaging() {
      return this.type === 'staging';
    },
    filteredModalHosts() {
      const isServer = this.type === 'server';
      if (this.typeGlobEntries.length && isServer) {
        return this.modalHosts.filter(host => {
          return this.typeGlobEntries.every(entry => {
            const wildcard = entry.name;
            const regex = new RegExp(escapeRegExp(wildcard).replace(/^\\\*/, '.*').replace(/\\\*$/, '.*'));
            return !regex.test(host.name);
          });
        });
      }
      return this.modalHosts;
    }
  },
  watch: {
    searchInput(newValue) {
      if (!this.hasMoreEntries) {
        return;
      }
      this.tableLoaded = false;
      this.debouncedTableSearch(newValue);
    }
  },
  created() {
    this.fetchListEntries();
    this.debouncedTableSearch = debounce(this.tableSearch, 1000);
    this.debouncedModalSearch = debounce(this.modalSearch, 1000);
  },
  methods: {
    tableSearch(searchTerm) {
      this.fetchEntries(searchTerm);
      this.fetchEntriesForGlob(searchTerm);
    },
    modalSearch(searchTerm) {
      this.modalHostsLoaded = false;
      this.fetchModalHosts(searchTerm);
    },
    addListItem(item) {
      if (this.isHostType) {
        this.loadingLabel = 'Adding entries...';
        this.isLoading = true;
        item.hosts = item.hosts || [];
        item.wildcards = item.wildcards || [];
        const hostPromises = item.hosts.map(host => {
          host.flags[this.isStaging ? 'staging' : 'blacklisted'] = true;
          return this.updateHost(host).then(() => {
            this.hostEntries.push(host);
            if (this.modalHostsLoaded) {
              this.modalHosts = this.modalHosts.filter(entry => {
                return entry.id !== host.id;
              });
            }
          });
        });
        const wildcardPromises = item.wildcards.map(wildcard => {
          return this.createExcludeListItem(wildcard).then(_ref => {
            let {
              data
            } = _ref;
            if (wildcard.type.includes('Glob')) {
              return this.typeGlobEntries.push(data);
            }
            return this.typeEntries.push(data);
          });
        });
        this.closeAddModal();
        Promise.all(hostPromises.concat(wildcardPromises)).catch(error => {
          this.isLoading = false;
          this.showErrorNotification(error, true);
        }).finally(() => {
          this.isLoading = false;
        });
      } else {
        return this.createExcludeListItem(item).then(_ref2 => {
          let {
            data
          } = _ref2;
          if (item.type.includes('Glob')) {
            this.typeGlobEntries.push(data);
          } else {
            this.typeEntries.push(data);
          }
          this.closeAddModal();
        }).catch(error => {
          this.closeAddModal();
          this.showErrorNotification(error, true);
        });
      }
    },
    clearHostList() {
      this.loadingLabel = 'Clearing entries...';
      this.isLoading = true;
      return this.transferHostList().then(() => {
        Promise.all(this.listEntries.map(item => {
          return this.removeItem(item);
        })).then(() => {
          this.isLoading = false;
        });
      });
    },
    closeAddModal() {
      this.showAddModal = false;
    },
    closeListConversionModal() {
      this.showListConversionModal = false;
    },
    closeRemoveModal() {
      this.showRemoveModal = false;
    },
    fetchListEntries() {
      return Promise.all([this.fetchEntries(), this.fetchEntriesForGlob()]).then(() => {
        this.initComplete = true;
        this.tableLoaded = true;
      });
    },
    fetchHosts: _async(function () {
      const _this = this;
      let searchTerm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return _invokeIgnored(function () {
        if (_this.isHostType) {
          const hostType = _this.type === 'server' ? 'blacklisted' : 'staging';
          return _await(_this.fetchHostsForType(hostType, false, searchTerm), function (_ref3) {
            let {
              data
            } = _ref3;
            _this.hostEntries = data.results.filter(host => {
              return host.name !== '';
            });
            _this.tableLoaded = true;
            if (data.hasMore) {
              _this.hasMoreEntries = true;
            }
          });
        }
      });
    }),
    fetchModalHosts: _async(function () {
      const _this2 = this;
      let searchTerm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      const hostType = _this2.type === 'server' ? 'blacklisted' : 'staging';
      return _await(_this2.fetchHostsForType(hostType, true, searchTerm), function (_ref4) {
        let {
          data
        } = _ref4;
        _this2.modalHosts = data.results.filter(host => {
          return host.name !== '';
        });
        _this2.modalHostsLoaded = true;
        if (data.hasMore) {
          _this2.modalHasMoreHosts = true;
        }
      });
    }),
    fetchEntries: _async(function () {
      const _this3 = this;
      let searchTerm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return _this3.isHostType ? _this3.fetchHosts(searchTerm) : _await(_this3.fetchExcludeListForType(_this3.type, searchTerm), function (_ref5) {
        let {
          data
        } = _ref5;
        _this3.typeEntries = data.results;
        _this3.tableLoaded = true;
        if (data.hasMore) {
          _this3.hasMoreEntries = true;
        }
      });
    }),
    fetchEntriesForGlob: _async(function () {
      const _this4 = this;
      let searchTerm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return _await(_this4.fetchExcludeListForType(`${_this4.type}Glob`, searchTerm), function (_ref6) {
        let {
          data
        } = _ref6;
        _this4.typeGlobEntries = data.results;
        _this4.tableLoaded = true;
        if (data.hasMore) {
          _this4.hasMoreEntries = true;
        }
      });
    }),
    handleListConversion() {
      return this.listConversionChoice === 'clear' ? this.clearHostList() : this.transferHostList();
    },
    openAddModal() {
      this.showAddModal = true;
      if (this.modalHostsLoaded) {
        return;
      }
      return this.fetchModalHosts();
    },
    openListConversionModal() {
      if (!this.showTable) {
        return this.transferHostList();
      }
      this.showListConversionModal = true;
    },
    openRemoveModal(host) {
      this.itemToRemove = host;
      this.showRemoveModal = true;
    },
    removeItem: _async(function (itemToRemove) {
      const _this5 = this;
      itemToRemove = itemToRemove || _this5.itemToRemove;
      return _continue(_catch(function () {
        return _invokeIgnored(function () {
          if (!itemToRemove.type) {
            itemToRemove.flags[_this5.isStaging ? 'staging' : 'blacklisted'] = false;
            return _await(_this5.updateHost(itemToRemove), function () {
              if (_this5.modalHostsLoaded) {
                _this5.modalHosts.push(itemToRemove);
              }
              _this5.hostEntries = _this5.hostEntries.filter(entry => {
                return entry.id !== itemToRemove.id;
              });
            });
          } else {
            return _await(_this5.removeExcludeListItem(itemToRemove), function () {
              const targetList = itemToRemove.type.includes('Glob') ? 'typeGlobEntries' : 'typeEntries';
              _this5[targetList] = _this5[targetList].filter(entry => entry.id !== itemToRemove.id);
            });
          }
        });
      }, function (error) {
        _this5.showErrorNotification(error, false);
      }), function () {
        _this5.closeRemoveModal();
      });
    }),
    transferHostList: _async(function () {
      const _this6 = this;
      return _await(_this6.accountUsesIncludeList(!_this6.usesIncludeList), function () {
        _this6.closeListConversionModal();
      });
    }),
    showErrorNotification(error, isAdding) {
      const listType = `${this.typeVerb} List`;
      const title = this.localizeApp ? this.localizeApp("{listType} wasn't updated", {
        listType
      }) : `${listType} wasn't updated`;
      PendoNotification({
        dangerouslyUseHTMLString: true,
        type: 'error',
        duration: 4000,
        title,
        message: this.getNotificationMessage(error, isAdding)
      });
    },
    getNotificationMessage(error, isAdding) {
      const {
        data,
        status
      } = error.response || {};
      let message = '';
      const listItemType = this.typeLabel;
      const listType = `${this.typeVerb} List`;
      if (!isAdding) {
        message = this.localizeApp ? this.localizeApp('Something went wrong when removing the {listItemType} from the {listType}. Please refresh and try again.', {
          listItemType,
          listType
        }) : `Something went wrong when removing the ${listItemType} from the ${listType}. Please refresh and try again.`;
        return message;
      }
      if (status === 400) {
        message = this.localizeApp ? this.localizeApp("We couldn't add the {listItemType} to the {listType}. {errorMessage}.", {
          listItemType,
          listType,
          errorMessage: data
        }) : `We couldn't add the ${listItemType} to the ${listType}. ${data}.`;
        return message;
      }
      message = this.localizeApp ? this.localizeApp('Something went wrong when adding the {listItemType} to the {listType}. Please refresh and try again.', {
        listItemType,
        listType
      }) : `Something went wrong when adding the ${listItemType} to the ${listType}. Please refresh and try again.`;
      return message;
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-exclude-include-staging-list-detail.vue2.js.map
